import { Component } from '@angular/core';

@Component({
  selector: 'app-loader-css',
  templateUrl: './loader-css.component.html',
  styleUrls: ['./loader-css.component.css']
})
export class LoaderCssComponent {

  constructor() { }
  
}
